import { z } from "zod";

export const BrowserTelemetrySignal = z.enum(["traces", "logs", "metrics"]);
export type BrowserTelemetrySignal = z.infer<typeof BrowserTelemetrySignal>;

/**
 * Where the browser's OpenTelemetry exporters post OTLP/HTTP JSON. Anyone may post, so signed-out
 * pages are traced; each post is capped in size and rate-limited per IP.
 */
export const browserTelemetry = {
  path: (signal: BrowserTelemetrySignal) => `/api/telemetry/v1/${signal}` as const,
  maxBodyBytes: 1_000_000,
} as const;
